const DEFAULT_TIME_ZONE = import.meta.env.VITE_DISPLAY_TIMEZONE || "America/Sao_Paulo";

export function parseApiDate(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  if (typeof value === "number") {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  let s = String(value).trim();
  if (!s) return null;

  const dotNetMatch = s.match(/^\/Date\((-?\d+)\)\/$/);
  if (dotNetMatch) {
    const d = new Date(Number(dotNetMatch[1]));
    return Number.isNaN(d.getTime()) ? null : d;
  }

  if (/^\d{4}-\d{2}-\d{2} /.test(s) && !s.includes("T")) {
    s = s.replace(" ", "T");
  }

  const hasTz = /(?:Z|[+-]\d{2}:\d{2})$/i.test(s);
  if (!hasTz) s = `${s}Z`;

  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDateTimeBR(value, options = {}) {
  const d = parseApiDate(value);
  if (!d) return "—";

  const { timeZone = DEFAULT_TIME_ZONE, ...rest } = options;
  return d.toLocaleString("pt-BR", { timeZone, ...rest });
}

export function toDateTimeLocalValue(value) {
  const d = parseApiDate(value);
  if (!d) return "";
  const year = String(d.getFullYear());
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hour = String(d.getHours()).padStart(2, "0");
  const minute = String(d.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
}
